(function(){
  var root=document.querySelector('.nz');if(!root)return;
  var fmt=function(c){return (c/100).toFixed(2).replace('.00','').replace('.',',')+' zł'};
  var $=function(s){return root.querySelector(s)},$$=function(s){return root.querySelectorAll(s)};

  /* odłożone obrazki (data-src, data-srcset, data-poster): reszta galerii, metamorfozy i okładki filmów
     idą dopiero po załadowaniu strony, żeby całe łącze dostało główne zdjęcie */
  var ld=function(el){
    if(el.dataset.srcset){el.srcset=el.dataset.srcset;el.removeAttribute('data-srcset')}
    if(el.dataset.src){el.src=el.dataset.src;el.removeAttribute('data-src')}
    if(el.dataset.poster){el.poster=el.dataset.poster;el.removeAttribute('data-poster')}
  };
  var lateDone=false,late=function(){if(lateDone)return;lateDone=true;$$('[data-src],[data-srcset],[data-poster]').forEach(ld)};
  if(document.readyState=='complete')setTimeout(late,200);else window.addEventListener('load',function(){setTimeout(late,200)});
  setTimeout(late,8000);

  /* filmy: pobieraj dopiero, gdy ktoś do nich przewinie */
  var lv=$$('video[data-lazyvid]');
  if(lv.length){
    var loadV=function(v){if(v.dataset.on)return;v.dataset.on='1';ld(v);v.querySelectorAll('source[data-src]').forEach(function(s){s.src=s.dataset.src});v.load()};
    var playV=function(v){var p=v.play();if(p&&p.catch)p.catch(function(){})};
    if('IntersectionObserver' in window){
      var vio=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.isIntersecting){loadV(v);playV(v)}else if(v.dataset.on){v.pause()}})},{rootMargin:'300px 0px'});
      lv.forEach(function(v){vio.observe(v)});
    }else{lv.forEach(function(v){loadV(v);playV(v)})}
  }

  /* licznik do północy (czas warszawski) */
  var cds=$$('[data-cd]');
  function tick(){
    var pl=new Date(new Date().toLocaleString('en-US',{timeZone:'Europe/Warsaw'}));
    var end=new Date(pl);end.setHours(24,0,0,0);
    var s=Math.max(0,Math.floor((end-pl)/1000));
    var t=[Math.floor(s/3600),Math.floor(s%3600/60),s%60].map(function(x){return x<10?'0'+x:x}).join(':');
    for(var i=0;i<cds.length;i++)cds[i].textContent=t;
  }
  tick();setInterval(tick,1000);

  /* daty: dostawa i serie */
  var mies=['stycznia','lutego','marca','kwietnia','maja','czerwca','lipca','sierpnia','września','października','listopada','grudnia'];
  var day=function(n){var x=new Date();x.setDate(x.getDate()+n);return x};
  var eta=$('[data-eta]');
  if(eta){
    var mn=+root.dataset.emin||3,mx=+root.dataset.emax||6,a=day(mn),b=day(mx);
    eta.textContent='między '+a.getDate()+' '+mies[a.getMonth()]+' a '+b.getDate()+' '+mies[b.getMonth()];
  }
  $$('[data-bd]').forEach(function(el){var d=day(+el.dataset.bd);el.textContent=d.getDate()+' '+mies[d.getMonth()]});

  /* warianty: kolor x rozmiar x zestaw */
  var vs=[];try{vs=JSON.parse($('[data-variants]').textContent)}catch(e){}
  var buns=$$('[data-o3]'),csel=$('[data-o1sel]'),sw=$('[data-sw]'),ssel=$('[data-o2sel]'),sel=$('[data-sel]');
  var pick=function(list){for(var i=0;i<list.length;i++)if(list[i].classList.contains('is-on'))return list[i];return list[0]};
  var o1=csel?csel.value:null,o2=ssel?ssel.value:null,o3=pick(buns)?pick(buns).dataset.o3:null;
  var find=function(a,b,c){for(var i=0;i<vs.length;i++)if(vs[i].o1==a&&vs[i].o2==b&&vs[i].o3==c)return vs[i];return null};
  var cur=null;
  function render(){
    buns.forEach(function(el){
      var v=find(o1,o2,el.dataset.o3);if(!v)return;
      el.querySelector('[data-pr]').textContent=fmt(v.p);
      el.querySelector('[data-cp]').textContent=v.c>v.p?fmt(v.c):'';
      el.querySelector('[data-sv]').textContent=(v.c>v.p&&/[23]/.test(v.o3))?'Oszczędzasz '+fmt(v.c-v.p):'';
    });
    cur=find(o1,o2,o3);
    if(cur){
      var bp=$('[data-btnp]'),bc=$('[data-bcp]'),st=$('[data-stl]');
      if(bp)bp.textContent=fmt(cur.p);if(bc)bc.textContent=cur.c>cur.p?fmt(cur.c):'';
      /* bez koloru i rozmiaru (np. kalendarz) pokazujemy nazwę zestawu */
      if(st)st.textContent=([o1,o2].filter(Boolean).join(' · ')||o3)+' · '+fmt(cur.p);
    }
  }
  function setBun(el){
    buns.forEach(function(x){x.classList.toggle('is-on',x==el);x.setAttribute('aria-checked',x==el?'true':'false')});
    o3=el.dataset.o3;if(sel&&sel.parentNode!=el)el.appendChild(sel);render();
  }
  buns.forEach(function(el){
    el.addEventListener('click',function(e){if(sel&&sel.contains(e.target))return;setBun(el)});
    el.addEventListener('keydown',function(e){if(e.target==el&&(e.key==' '||e.key=='Enter')){e.preventDefault();setBun(el)}});
  });
  if(ssel)ssel.addEventListener('change',function(){o2=ssel.value;render()});

  /* galeria: zdjęcia wybranego koloru */
  var gal=$('[data-gal]'),gi=$$('[data-gal] img'),th=$$('[data-thumbs] button');
  function showColor(c){
    var any=false;gi.forEach(function(im){if(im.dataset.c==c)any=true});
    gi.forEach(function(im){im.hidden=any&&im.dataset.c!=c&&im.dataset.c!='*'});
    th.forEach(function(b){b.hidden=any&&b.dataset.c!=c&&b.dataset.c!='*'});
    var first=[].filter.call(gi,function(im){return !im.hidden})[0];if(first)ld(first);
    if(gal)gal.scrollLeft=0;markThumb();
  }
  function setColor(c){
    if(!csel)return;csel.value=c;o1=csel.value;
    var op=csel.options[csel.selectedIndex];if(sw&&op)sw.style.setProperty('--c',op.dataset.c);
    showColor(o1);render();
  }
  if(csel)csel.addEventListener('change',function(){setColor(csel.value)});
  function vis(){return [].filter.call(th,function(b){return !b.hidden})}
  function markThumb(){var k=gal?Math.round(gal.scrollLeft/gal.clientWidth):0;vis().forEach(function(b,j){b.classList.toggle('on',j==k)})}
  if(gal){
    gal.addEventListener('scroll',function(){late();markThumb()},{passive:true});
    th.forEach(function(b){b.addEventListener('click',function(){late();var j=vis().indexOf(b);gal.scrollTo({left:j*gal.clientWidth,behavior:'smooth'})})});
  }

  /* ?kolor= albo ?variant= z innych stron */
  var q=new URLSearchParams(location.search),qk=q.get('kolor'),qv=+q.get('variant');
  if(qv)vs.forEach(function(v){if(v.id==qv){qk=v.o1;o2=v.o2;if(ssel)ssel.value=o2;buns.forEach(function(b){if(b.dataset.o3==v.o3)setBun(b)})}});
  setColor(qk&&csel&&[].some.call(csel.options,function(o){return o.value==qk})?qk:o1);
  if(!csel)render();

  /* kupno: dodaj do koszyka i od razu do kasy (kalendarz .cl: do koszyka z upsellem) */
  var msg=$('[data-msg]');
  $$('[data-buy]').forEach(function(b){
    b.addEventListener('click',function(){
      if(!cur)return;b.disabled=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:cur.id,quantity:1}]})})
        .then(function(r){if(!r.ok)throw 0;location.href=root.classList.contains('cl')?'/cart':'/checkout'})
        .catch(function(){b.disabled=false;if(msg)msg.hidden=false});
    });
  });

  /* przewijanie */
  $$('[data-scroll]').forEach(function(a){a.addEventListener('click',function(e){var t=document.getElementById('top-buy');if(!t)return;e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'})})});
  $$('[data-scrollto]').forEach(function(a){a.addEventListener('click',function(e){var t=document.querySelector(a.getAttribute('href'));if(!t)return;e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'})})});

  /* sticky przycisk */
  var sk=$('[data-sticky]'),main=$('.nz-buy .nz-btn');
  if(sk&&main&&'IntersectionObserver' in window){
    new IntersectionObserver(function(en){var vis=en[0].isIntersecting,past=en[0].boundingClientRect.top<0,show=!vis&&past;sk.classList.toggle('is-on',show);sk.setAttribute('aria-hidden',show?'false':'true');sk.querySelector('button').tabIndex=show?0:-1}).observe(main);
  }
})();
